// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeading\"> Pay by Third-Party Bill-Pay Services </h1> <p>If you use a bill-pay service or pay through your bank, be sure that they have our <a href=\"/contactUsMailFax\" target=\"_blank\">correct address</a> so that your payment is sent to the right place.</p> ";
// Exports
export default code;